import { BRAND } from "../lib/brand";

const TICKS = Array.from({ length: 32 }, (_, i) => i);
const BRANCHES = [
  ["ANTIGUA", "BARBADOS", "BARBADOS-AIRPORT", "DOMINICA", "GRENADA"],
  ["GUYANA", "JAMAICA 1-876-903-3276", "ST. LUCIA", "ST. VINCENT"],
  ["SURINAME", "TRINIDAD-P.O.S.", "TRINIDAD-PT. LISAS", "TRINIDAD-AIRPORT"],
];
const VAL = "font-mono uppercase text-[#1E2A78] font-bold";

function Box({ on, label, testId }) {
  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap" data-testid={testId}>
      {label && <span>{label}</span>}
      <span className="inline-flex items-center justify-center h-[13px] w-[13px] border border-black text-[11px] leading-none text-[#1E2A78] font-bold">{on ? "✕" : ""}</span>
    </span>
  );
}

function CombRow({ cells }) {
  return (
    <div className="flex border-b border-black h-[29px]">
      {cells.map(([label, value]) => (
        <div key={label} className="relative flex-1 overflow-hidden">
          <div className="absolute inset-x-0 bottom-0 h-[12px] flex pl-[24px]">{TICKS.map((t) => <span key={t} className="shrink-0 w-[26px] h-full border-l border-black" />)}</div>
          <div className="relative text-[8.5px] font-bold pl-1.5 pt-[2px] leading-[10px]">{label}</div>
          <div className={`relative pl-2 text-[11px] leading-[15px] whitespace-nowrap ${VAL}`}><span className="bg-[var(--paper)] px-0.5">{value || "\u00a0"}</span></div>
        </div>
      ))}
    </div>
  );
}

function Party({ title, p, consignee }) {
  return (
    <div>
      <div className="text-[12px] font-extrabold italic mb-0.5">{title}</div>
      <div className={`border-t border-l border-black ${consignee ? "border-r" : ""}`}>
        <CombRow cells={[["COMPANY", p.company]]} />
        <CombRow cells={[["FIRST NAME", p.first_name]]} />
        <CombRow cells={[["LAST NAME", p.last_name]]} />
        <CombRow cells={[["ADDRESS", p.address]]} />
        <CombRow cells={consignee ? [["CITY", p.city], ["PARISH", p.parish]] : [["CITY", p.city], ["STATE", p.state], ["ZIP CODE", p.zip_code]]} />
        <CombRow cells={[["COUNTRY", p.country]]} />
        <CombRow cells={[["TELEPHONE 1", p.phone], ["ALTERNATE TELEPHONE", p.alt_phone]]} />
        <CombRow cells={[["EMAIL", p.email]]} />
      </div>
    </div>
  );
}

function Header({ r }) {
  return (
    <>
      <div className="grid grid-cols-[1fr_auto_1fr] gap-3 items-start">
        <div className="flex gap-2">
          <img src={BRAND.logo} alt="Amplartic Logistics" className="h-[78px] w-[78px] object-contain mix-blend-multiply" />
          <div className="text-[9.5px] font-bold leading-[1.35]">
            <div>Amplartic logistics Canada Inc.</div><div>7-20121 115A Ave, Maple Ridge</div><div>V2X 0Z3 British Columbia, Canada</div>
            <div>Brampton Ontario, Canada</div><div>Sunrise, Florida, USA</div><div>Tel: {BRAND.phone}</div><div>https://amplarticlogistics.com/</div>
          </div>
        </div>
        <div className="text-center">
          <div className="text-[25px] font-extrabold tracking-tight leading-none">WAREHOUSE RECEIPT</div>
          <div className="text-[11px] font-bold mt-2">CIRCLE ONE</div>
          <div className="inline-flex border border-black text-[11px] font-bold mt-0.5">
            {["Ocean", "Air", "Express"].map((m, i) => (
              <span key={m} className={`px-3 py-0.5 ${i ? "border-l border-black" : ""} ${r.mode === m ? "rounded-full ring-2 ring-[#1E2A78] ring-inset text-[#1E2A78]" : ""}`} data-testid={`receipt-doc-mode-${m}`}>{m}</span>
            ))}
          </div>
        </div>
        <div className="text-right text-[26px] font-extrabold tracking-tight" data-testid="receipt-doc-number">{r.receipt_number}</div>
      </div>
      <div className="grid grid-cols-3 text-[9px] leading-[1.25] font-bold mt-1 pl-2">
        {BRANCHES.map((col) => <div key={col[0]}>{col.map((b) => <div key={b}>{b}</div>)}</div>)}
      </div>
      <div className="text-[10px] font-bold mt-2">BL/AWB NO <span className={`inline-block min-w-[180px] border-b border-black ${VAL}`}>{r.bl_awb_no || "\u00a0"}</span></div>
      <div className="text-[10px] font-semibold leading-snug">Please print clearly in capital letters, do not abbreviate. Correct addresses and names are needed for timely delivery. Delays may be outside the control of Amplartic Logistics. Please confirm all information is correctly stated.</div>
    </>
  );
}

function Items({ r }) {
  const rows = [...r.items, ...Array(Math.max(0, 8 - r.items.length)).fill(null)];
  const td = "border-r border-black px-1 h-[17px] text-[10px]";
  return (
    <table className="w-full border-collapse border-x border-b border-black" data-testid="receipt-doc-items">
      <thead className="text-[10px] font-bold">
        <tr className="border-b border-black">
          <th rowSpan={2} className="border-r border-black w-[11%] leading-tight">NUMBER OF<br />PACKAGES</th>
          <th rowSpan={2} className="border-r border-black w-[37%]">DESCRIPTION OF PACKAGES &amp; GOODS</th>
          <th colSpan={3} className="border-r border-black border-b">MEASUREMENTS</th>
          <th rowSpan={2} className="border-r border-black w-[10%]">CUBIC</th>
          <th rowSpan={2} className="border-r border-black w-[10%] leading-tight">GROSS<br />WEIGHT</th>
          <th rowSpan={2} className="w-[16%] leading-tight">REMARKS &amp; SEAL<br />NO.(S)</th>
        </tr>
        <tr className="border-b border-black">{["L", "W", "H"].map((x) => <th key={x} className="border-r border-black w-[5.3%]">{x}</th>)}</tr>
      </thead>
      <tbody className={VAL}>
        {rows.map((it, i) => (
          <tr key={it ? `item-${i}` : `blank-${i}`} className="border-b border-black">
            <td className={`${td} text-center`}>{it?.qty}</td><td className={td}>{it?.description}</td>
            <td className={`${td} text-center`}>{it?.length}</td><td className={`${td} text-center`}>{it?.width}</td><td className={`${td} text-center`}>{it?.height}</td>
            <td className={`${td} text-center`}>{it?.cubic}</td><td className={`${td} text-center`}>{it?.weight_lbs}</td><td className="px-1 text-[10px]">{it?.remarks}</td>
          </tr>
        ))}
        <tr className="text-[10px]">
          <td className="border-r border-black text-center font-sans text-black font-bold">TOTAL PCS <span className={VAL}>{r.total_pieces}</span></td>
          <td colSpan={4} className="border-r border-black" />
          <td className="border-r border-black text-center"><div className="font-sans text-black font-bold text-[9px]">TOTAL CUBIC</div>{r.total_cubic || ""}</td>
          <td className="border-r border-black text-center"><div className="font-sans text-black font-bold text-[9px]">TOTAL WEIGHT</div>{r.total_weight_lbs || ""}</td>
          <td />
        </tr>
      </tbody>
    </table>
  );
}

function Declaration({ r }) {
  const yn = (v, key) => <><Box on={v === true} label="YES" testId={`receipt-doc-${key}-yes`} /> <Box on={v === false} label="NO" testId={`receipt-doc-${key}-no`} /></>;
  const row = "flex items-center justify-between gap-2";
  return (
    <div className="grid grid-cols-[28%_25%_25%_22%] border-x border-b border-black text-[11px] font-bold">
      <div className="border-r border-black p-1.5">
        <div className="flex justify-between items-start"><span className="text-[15px] font-extrabold">DECLARATION</span><span className="text-[7.5px] italic text-right leading-tight">PLEASE READ<br />OVERLEAF</span></div>
        <div className="text-[8.5px] leading-tight mt-0.5">All cargo is automatically insured based on the declared value. If you do not want to insure your cargo, please check the &quot;decline&quot; box below. <span className="text-[10px]">Declared Value Of Cargo for Insurance</span> <span className={`border-b border-black inline-block min-w-[70px] ${VAL}`}>{r.declared_value != null ? `$${r.declared_value}` : "\u00a0"}</span></div>
        <div className="text-center mt-1"><Box on={r.insurance_declined} label="DECLINED" testId="receipt-doc-declined" /></div>
        <div className="mt-1">Signature</div><div>X<span className="inline-block w-[85%] border-b border-black" /></div>
      </div>
      <div className="border-r border-black p-2 flex flex-col justify-around gap-2">
        <div className={row}><span>DOOR TO DOOR</span><span className="inline-flex gap-1">{yn(r.door_to_door, "door")}</span></div>
        <div className={row}><span>BROKERAGE</span><span className="inline-flex gap-1">{yn(r.brokerage, "brokerage")}</span></div>
        <div className={row}><Box on={r.cargo_type === "commercial"} label="COMMERCIAL" testId="receipt-doc-commercial" /><Box on={r.cargo_type === "personal"} label="PERSONAL" testId="receipt-doc-personal" /></div>
      </div>
      <div className="border-r border-black p-2 flex flex-col justify-around gap-2">
        {[["prepaid", "PRE-PAID"], ["freight_collect", "FREIGHT COLLECT"], ["on_account", "ON ACCOUNT"]].map(([k, l]) => (
          <div key={k} className={row}><span>{l}</span><Box on={r.payment_terms === k} testId={`receipt-doc-${k}`} /></div>
        ))}
      </div>
      <div className="p-2 flex flex-col justify-between">
        <div>RECEIPT NO</div>
        <div className={`border-b border-black text-center ${VAL}`}>{r.receipt_number}</div>
        <div className="text-[14px]">HST <span className="text-[17px]">0</span> RATED</div>
      </div>
    </div>
  );
}

function Line({ label, value, className = "" }) {
  return <span className={`inline-flex items-end gap-1 ${className}`}><span className="whitespace-nowrap">{label}</span><span className={`flex-1 border-b border-black min-w-[60px] px-1 ${VAL}`}>{value || "\u00a0"}</span></span>;
}

function Endorsement({ r }) {
  return (
    <div className="grid grid-cols-2 gap-3 mt-1">
      <div className="text-[8px] font-bold">
        <div className="text-center text-[14px] font-extrabold">Shippers&apos; Security Endorsement (SSE)</div>
        <div className="text-center text-[10px] italic">PLEASE READ OVERLEAF</div>
        <p className="mt-1 leading-tight">Amplartic Logistics IS NOT RESPONSIBLE FOR ANY CARGO LEFT ON PREMISES WITHOUT SHIPPING ARRANGEMENTS BEING MADE!! SHIPPING ARRANGEMENTS FOR ALL CARGO MUST BE MADE AT TIME OF DELIVERY.</p>
        <p className="mt-2 leading-tight">I, THE UNDERSIGNED, FULLY UNDERSTAND THAT THE FOLLOWING STORAGE FEES APPLY: AFTER 14 DAYS - $0.20 PER CUBIC FT. PER DAY. AFTER 90 DAYS MY CARGO WILL BE DISPOSED OF TO OFFSET STORAGE CHARGES INCURRED.</p>
        <div className="flex gap-3 mt-3 text-[10px]"><Line label="Delivered By X" value={r.delivered_by} className="flex-[2]" /><Line label="Date" value={r.date} className="flex-1" /></div>
        <div className="flex gap-3 mt-2 text-[10px]"><Line label="Receiving Clerk." value={r.receiving_clerk} className="flex-[2]" /><Line label="Time" value={r.received_time} className="flex-1" /></div>
      </div>
      <div className="border border-black p-1.5 text-[10px] font-bold self-start">
        <p className="leading-tight">I certify that this cargo does not contain any unauthorized explosives, incendiary devices, hazardous materials, ammunition, combustible materials, undeclared weapons or currency. I consent to screening and/or search of this cargo. I am aware that this endorsement and original signature, along with other shipping documents will be retained on file for at least thirty days. SHIPPER IS RESPONSIBLE FOR ALL COST INCURRED DUE TO FALSE DECLARATION</p>
        <div className="mt-4">X.<span className="inline-block w-[95%] border-b border-black" /></div>
        <div>Signature of Shipper or Authorized Representative</div>
        <div className="mt-3 flex items-end">X.<span className={`flex-1 border-b border-black px-1 ${VAL}`}>{r.shipper_print_name || "\u00a0"}</span></div>
        <div>Print/type name of individual whose signature appears as shipper / Authorized Representative</div>
      </div>
    </div>
  );
}

export function ReceiptDocument({ r, copy = "customer" }) {
  return (
    <div className="relative bg-[var(--paper)] text-black px-7 py-6 w-[816px] mx-auto receipt-doc" style={{ fontFamily: "Arial, Helvetica, sans-serif", "--paper": copy === "customer" ? "#FFFCC7" : "#FFFFFF" }} data-testid="receipt-document">
      {r.voided && <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10"><span className="text-8xl font-extrabold text-red-600/30 -rotate-12 border-8 border-red-600/30 px-6">VOID</span></div>}
      <Header r={r} />
      <div className="grid grid-cols-2 mt-1">
        <Party title="FROM: (SHIPPER INFORMATION)" p={r.shipper} />
        <Party title="TO; (CONSIGNEE INFORMATION)" p={r.consignee} consignee />
      </div>
      <Items r={r} />
      <Declaration r={r} />
      <div className="text-[11px] font-bold mt-1">ALL CARGO TENDERED IS SUBJECT TO SEARCH AND INSPECTION AS PER TSA RULES</div>
      <div className="text-[11px] font-bold flex flex-wrap items-center gap-2">I agree to the terms and conditions of this contract. I also declare that the items I am shipping are hereby noted as being:
        <span className="text-[13px] inline-flex gap-4"><Box on={r.hazardous === true} label="HAZARDOUS" testId="receipt-doc-hazardous" /><Box on={r.hazardous === false} label="NON-HAZARDOUS" testId="receipt-doc-non-hazardous" /></span>
      </div>
      <div className="flex gap-6 text-[11px] font-bold mt-2"><Line label="Customer's Signature X." value="" className="flex-[3]" /><Line label="Date" value={r.date} className="flex-1" /></div>
      <Endorsement r={r} />
      <div className="mt-1 text-[15px] font-extrabold flex items-center gap-3">EXAMINED <span className="text-[11px] inline-flex gap-3"><Box on={r.examined === true} label="YES" testId="receipt-doc-examined-yes" /><Box on={r.examined === false} label="NO" testId="receipt-doc-examined-no" /></span></div>
      <p className="text-[7.5px] font-bold leading-tight">Received the above-described merchandise in apparent good order and condition, except as noted to be held and transported subject to all the terms and conditions contained in the regular form of Bill of Lading of the carrier which are incorporated herein and shall be considered a part hereof with the same force and effect as if set forth herein in full. The goods are received subject to delay, carrier&apos;s inability to carry due to accumulation of goods, lack of conveyance&apos;s, space or facilities of any sort, labor disturbances, strikes, lockouts, riots, war, government authority, or any condition whatsoever beyond the control of the carrier. Any valuation in excess of $500.00 for Ocean Freight, or $250.00 for Air Freight, per customary shipping unit as provided for in the carrier&apos;s regular form of Bill of Lading, shall be declared in writing by the Shipper upon delivery to the carrier and shall be inserted herein as well as in the Bill of Lading and extra freight paid for. Nothing in this warehouse receipt shall operate to limit or deprive the carrier of any statutory protection or exemption of limitation of liability.</p>
      <div className="flex gap-6 text-[8.5px] font-bold mt-4"><Line label="Driver's/Receiving Signature" value="" className="flex-[3]" /><Line label="Date" value="" className="flex-[2]" /></div>
      <div className="text-center text-[8.5px] font-bold mt-0.5">See Terms &amp; Conditions on Reverse.</div>
      {r.notes && <div className="mt-2 text-[9px] border-t border-dashed border-black pt-1"><b>Office notes:</b> <span className={VAL}>{r.notes}</span></div>}
    </div>
  );
}
